
import * as Yup from 'yup';

const checkScriptAvailible = (value) => {
    const reg = /<script/;
    return !reg.test(value || '');
};

export const offerFormSchema = Yup.object().shape({
    display_line: Yup.string()
        .test('checkScriptAvailible', 'The field contains prohibited characters.', checkScriptAvailible)
        .required('Input is required'),
    team: Yup.string()
        .test('checkScriptAvailible', 'The field contains prohibited characters.', checkScriptAvailible)
        .required('Input is required'),
    cc: Yup.string()
        .test('checkScriptAvailible', 'The field contains prohibited characters.', checkScriptAvailible)
        .required('Input is required'),
    language: Yup.string()
        .test('checkScriptAvailible', 'The field contains prohibited characters.', checkScriptAvailible)
        .required('Input is required'),
    model: Yup.string()
        .test('checkScriptAvailible', 'The field contains prohibited characters.', checkScriptAvailible)
        .required('Input is required'),
    price: Yup.string()
        .test('checkScriptAvailible', 'The field contains prohibited characters.', checkScriptAvailible)
        .required('Input is required'),
    cr: Yup.string()
        .test('checkScriptAvailible', 'The field contains prohibited characters.', checkScriptAvailible)
        .required('Input is required'),
    funnels: Yup.string()
        .test('checkScriptAvailible', 'The field contains prohibited characters.', checkScriptAvailible)
        .required('Input is required'),
    sources: Yup.string()
        .test('checkScriptAvailible', 'The field contains prohibited characters.', checkScriptAvailible)
        .required('Input is required'),
});